export default __webpack_public_path__ + "static/web_development_bootcamp_barcelona_code_school-48c3f5301f08ca4da3d794302eb55b42.jpg";